import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  query,
  orderBy,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyAux3Da3koBJwZdtHGNm_wnCW-eXpCAnFw',
  authDomain: 'mobile-invitation-ffc45.firebaseapp.com',
  projectId: 'mobile-invitation-ffc45',
  storageBucket: 'mobile-invitation-ffc45.firebasestorage.app',
  messagingSenderId: '954657416019',
  appId: '1:954657416019:web:8c99d761d1d86999f237a6',
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, addDoc, getDocs, deleteDoc, doc, query, orderBy };
